import React, { Component } from "react";
import PropTypes from "prop-types";
import { fontSelectStyle } from "../../../../styled/details/stylesSelect";
import { connect, useSelector } from "react-redux";
import TLDRBrowseMoreFontsModal from "./TLDRBrowseMoreFontsModal";
import { ADD_MORE_FONTS } from "../../../../../_utils/constants";
import axios from "axios";
import { fetchedFonts, fontsGetAdded } from "../../../../../_actions/appActions";
import {
  withAsyncPaginate,
  reduceGroupedOptions,
} from "react-select-async-paginate";
import { useTranslation, withTranslation } from "react-i18next";
import { chakraComponents } from "chakra-react-select";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Text,
  Flex,
} from "@chakra-ui/react";
import { FONTS_ENDPOINT } from "../../../../../_actions/endpoints";
import { StyledBrandkitTitle } from "apps/simplified-web/src/_components/styled/details/stylesTextPanel";
import { Select } from "chakra-react-select";
import { isEmpty } from "lodash";

const CustomAsyncPaginate = withAsyncPaginate(Select);

class TLDRFontOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMoreFontBrowser: false,
      fontListKey: 1
    };

    this.addMoreFontLabel = ADD_MORE_FONTS;
    this.loadOptions = this.loadOptions.bind(this);
  }

  fillOptions = (bk) => {
    let options = [];
    bk.fonts.map((font) => {
      options.push({
        value: font?.id || font.family,
        label: font.family,
      });
    });

    return options;
  };

  render() {
    const { font, fonts, canvasRef, fontId, t } =
      this.props;
    const { showMoreFontBrowser } = this.state;

    let myFontList = fonts.filter((font, index) => font.organization !== null);
    myFontList = myFontList.map((font) => ({
      value: font?.id || font.family,
      label: font.family,
    }));

    // TODO: Improve to find valueIndex
    let valueIndex = myFontList.find((ele) => ele.value === fontId);

    return (
      <>
        <CustomAsyncPaginate
          key={this.state.fontListKey} //using dynamic key to render font dropdown after added new fonts
          SelectComponent={Select}
          menuPosition={this.props.isMobileView ? "fixed" : ""}
          value={
            valueIndex > 0
              ? myFontList[valueIndex]
              : { value: fontId || font, label: font }
          }
          onChange={this.onChange}
          loadOptions={this.loadOptions}
          chakraStyles={fontSelectStyle}
          styles={fontSelectStyle}
          placeholder={t("fonts.font")}
          isSearchable
          components={{
            Group,
            GroupHeading: () => {
              return null;
            },
          }}
          additional={{
            page: 1,
          }}
          debounceTimeout={500}
          reduceOptions={reduceGroupedOptions}
        />
        <TLDRBrowseMoreFontsModal
          show={showMoreFontBrowser}
          onHide={this.hideMoreFontBrowser}
          canvasRef={canvasRef}
        />
      </>
    );
  }

  onChange = (selected) => {
    if (selected.label === this.addMoreFontLabel) {
      this.browseMoreFonts();
      return;
    }
    this.props.onFontChange(selected);
  };

  browseMoreFonts = () => {
    this.setState({
      showMoreFontBrowser: true,
      fontListKey: this.state.fontListKey + 1
    });
  };

  hideMoreFontBrowser = () => {
    this.setState({
      showMoreFontBrowser: false,
    });
  };

  onMenuClose = (data) => {};

  loadOptions(search, loadedoptions, { page }) {
    const { canvasRef, t, fonts, fetchedFonts, loadMore, fontListPage } = this.props;
    let myFontList = fonts.filter(font => font.organization !== null);
    myFontList = myFontList.map((font) => ({
      value: font?.id || font.family,
      label: font.family,
    }));
    
    let fontOptions = [
      { label: this.addMoreFontLabel, value: "" },
      {
        label: t("fonts.my_fonts"),
        options: myFontList,
      },
    ];

    if(!loadMore && !search) {
      return {
        options: fontOptions,
        hasMore: false,
        additional: {
          page: fontListPage,
        }
      }
    }
    if(!isEmpty(fonts) && page === 1 && !search) {
      return {
        options: fontOptions,
        hasMore: loadMore,
        additional: {
          page: fontListPage,
        }
    }
  }
    // Search font from remote server by family name
    const FONT_SEARCH_ENDPOINT = search
      ? `${FONTS_ENDPOINT}?search=${search}`
      : `${FONTS_ENDPOINT}?page=${fontListPage}`;
    return axios
      .get(FONT_SEARCH_ENDPOINT)
      .then((res) => {
        const newFonts =
          res?.data?.results.map((font, index) => ({
            value: font.id,
            label: font.family,
          })) || [];
        // Add font face file into DOM
        canvasRef?.handler.fontHandler.addFonts(res?.data?.results);
        this.props.fontsGetAdded(newFonts);
        let filteredOptions;
        if (!search && page === 1) {
          filteredOptions = [
            { label: this.addMoreFontLabel, value: "" },
            {
              label: t("fonts.my_fonts"),
              options: newFonts,
            },
          ];
        } else {
          filteredOptions = [{ label: t("fonts.my_fonts"), options: newFonts }];
        }
        const data = {
          results: res?.data?.results,
          next:res?.data?.next,
          previous: res?.data?.previous 
        }
        if(!search) fetchedFonts(data);
        return {
          options: filteredOptions,
          hasMore: res?.data?.next,
          additional: {
            page: fontListPage,
          },
        };
      })
      .catch(() => {
        console.error("Failed to fetch fonts");
        return {
          options: [],
          hasMore: false,
        };
      });
  }
}

TLDRFontOptions.propTypes = {
  onFontChange: PropTypes.func.isRequired,
};

TLDRFontOptions.defaultProps = {
  font: "Roboto",
  fontId: null,
};

const Group = (props) => {
  const brandkits = useSelector((state) => state.brandKit.brandkitPayload);
  const { t } = useTranslation(["planner"]);
  function onChangeFont(selected) {
    props.selectOption(selected);
  }
  function onBrandkitFontChange(selected) {
    props.selectOption(selected);
  }

  const childElements = props.children.map((ele, index) => {
    const isSelected = props.selectProps.value.value === ele.props.data.value;
    return (
      <Text
        key={index}
        fontSize="15px"
        fontFamily={ele.props.data.label}
        p="0.4rem 0.8rem"
        _hover={{
          cursor: "pointer",
          backgroundColor: "gray.1200",
        }}
        color={isSelected ? "primary.400" : "gray.100"}
        onClick={() => onChangeFont(ele.props.data)}
      >
        {ele.props.children}
      </Text>
    );
  });

  return (
    <div>
      <Accordion defaultIndex={brandkits.length ? brandkits.length : 0} allowToggle>
        {brandkits.length > 0 &&
          brandkits.map((bk, index) => (
            <AccordionItem key={bk.id}>
              <AccordionButton as={Flex} align="center" justify="space-between">
                {bk.title}
                <AccordionIcon />
              </AccordionButton>

              <AccordionPanel>
                {bk.fonts.length === 0 ? (
                  <StyledBrandkitTitle>
                    {t("brandkit.no_fonts_message")}
                  </StyledBrandkitTitle>
                ) : (
                  bk.fonts.length > 0 &&
                  bk.fonts.map((font, idx) => (
                    <Text
                      key={idx}
                      fontSize="sm"
                      fontFamily={font.family}
                      p="0.4rem 0.8rem"
                      _hover={{
                        cursor: "pointer",
                        backgroundColor: "gray.1200",
                      }}
                      color={
                        props.selectProps.value.value === font.id
                          ? "primary.400"
                          : "gray.100"
                      }
                      onClick={() =>
                        onBrandkitFontChange({
                          label: font.family,
                          value: font?.id || font.family,
                        })
                      }
                    >
                      {font.family}
                    </Text>
                  ))
                )}
              </AccordionPanel>
            </AccordionItem>
          ))}
        <AccordionItem>
          <AccordionButton as={Flex} align="center" justify="space-between">
            {props.label}
            <AccordionIcon />
          </AccordionButton>

          <AccordionPanel>
            <chakraComponents.Group {...props}>
              {childElements}
            </chakraComponents.Group>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};


const mapStateToProps = (state) => ({
  fonts: state.app.fontList,
  rightsidebar: state.rightsidebar,
  isMobileView: state.app.isMobileView,
  brandkits: state.brandKit.brandkitPayload,
  loadMore: state.app.loadMore,
  fontListPage: state.app.page,
  isMobileView:state.app.isMobileView
});

const mapDispatchToProps = (dispatch) => ({
  fontsGetAdded: (fonts) => dispatch(fontsGetAdded(fonts)),
  fetchedFonts: (data) => dispatch(fetchedFonts(data))
});

export default withTranslation(["studio", "planner"])(
  connect(mapStateToProps, mapDispatchToProps)(TLDRFontOptions)
);
